import { useSelector } from "react-redux";
import MyfeedInfo from "../UserProfileInfo/MyfeedInfo";
import MyPosts from "../UserProfileInfo/MyPosts";
import UserCompo from "../UserProfileInfo/UserCompo";
import UserPersonalCompo from "../UserProfileInfo/UserPersonalCompo";



const CommunityProfileSidebar = ({ setIsProfile }) => {
  // Add prop validation to catch errors early
  const exploreType = useSelector((state) => state?.community?.exploreType);

  return (
    <div
      style={{
        width: "25%",
        textAlign: "left",
        margin: "10px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          minHeight: "80vh",
          overflowY: "scroll",
          scrollbarWidth: "none",
          scrollBehavior: "smooth",
        }}
      >
        {exploreType && exploreType == "PERSONAL" ?  <UserPersonalCompo/> : <UserCompo />}
        <MyPosts />
        <MyfeedInfo />
      </div>
    </div>
  );
};

export default CommunityProfileSidebar;
